module.exports = __webpack_public_path__ + "static/img/arrow-level.64ede22c.svg";